import { confirm } from "@bps/fluent-ui";
import { useDialogOpenedAnalytics } from "@libs/analytics/hooks/useDialogOpenedAnalytics.ts";
import { ContactStatus } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

export const usePatientReactivation = () => {
  const { practice, core, notification } = useStores();
  const patientLabel = usePatientLabel();
  const patientLabelCapitalized = usePatientLabel(true);
  const trackDialogOpened = useDialogOpenedAnalytics();

  const onReactivatePatient = async (id: string) => {
    const patient = await practice.getContact(id);

    const withComma = (label: string, value?: string) =>
      !!value?.trim() ? `, ${label} ${value}` : "";

    const title = patient.title
      ? core.ref.titles.values.find(ref => ref.code === patient.title)?.text
      : "";

    const postCode = withComma("postcode", patient.physicalAddress?.postCode);
    const dob = withComma("dob", patient.birthDate?.toDayDefaultFormat());
    const patientDetails = `${patientLabelCapitalized} ${title} ${patient.preferredFullName}${dob}${postCode}`;
    const subText = `${patientDetails} will be restored to Active status. Refer to the Knowledge Base for a description of the reactivate ${patientLabel} function`;

    trackDialogOpened("Patient merge reactivation dialog", core.user?.fullName);

    const ok = await confirm({
      confirmButtonProps: { text: "Confirm and reactivate" },
      dialogContentProps: {
        title: `Confirm reactivate ${patientLabel}`,
        subText
      }
    });

    if (ok) {
      try {
        await practice.updatePatientMergedStatus(id, {
          status: ContactStatus.Active
        });
        notification.success("Merged patient reactivated");
      } catch (e) {
        notification.error(e.message);
      }
    }
  };

  return { onReactivatePatient };
};
